module.exports = __webpack_public_path__ + "static/media/details-16-image-3.d11c23ed.jpg";